export default "__VITE_ASSET__CyoAzLmS__"